<template>
  <div>
    pay: {{ goodsId }}
  </div>
</template>

<script>
export default {
  name: 'pay',
  data() {
    return {}
  },
  computed: {
    goodsId() {
      return this.$route.params.id
    }
  },
  methods: {
    pay() {
      
    }
  }
}
</script>

<style>

</style>